export default "__VITE_ASSET__Dao6bYkL__"